import React, { useId } from 'react';
import { DS } from './ds';
interface LogoProps {
  light?: boolean;
  size?: 'sm' | 'md' | 'lg';
}
const alinovaLogoAsset = 'https://cdn.magicpatterns.com/uploads/htp2phTwapvM9t2KEJh67u/Propuesta_LOGO_Final_Alinova_20260720_142521_0000.png';
export const Logo = ({
  light = false,
  size = 'md'
}: LogoProps) => {
  const dimensions = {
    sm: {
      width: 192,
      height: 55
    },
    md: {
      width: 224,
      height: 64
    },
    lg: {
      width: 280,
      height: 80
    }
  };
  const {
    width,
    height
  } = dimensions[size];
  const filterId = `alinova-logo-cutout-${useId().replace(/:/g, '')}`;
  return <svg width={width} height={height} viewBox="200 510 1200 350" role="img" aria-label="Alinova" style={{
    display: 'block',
    overflow: 'hidden',
    filter: light ? 'brightness(0) invert(1)' : 'none'
  }} data-id="element-854" data-mp="1comes0i6x8b4">
      <defs data-id="element-855" data-mp="2o5maz77ns7af">
        <filter id={filterId} colorInterpolationFilters="sRGB" data-id="element-856" data-mp="2t2kyh6wthfzn">
          <feColorMatrix in="SourceGraphic" type="matrix" values="1 0 0 0 0
                    0 1 0 0 0
                    0 0 1 0 0
                    -1 -1 -1 0 3" data-id="element-857" data-mp="2t0rrfqiaktr4" />
          <feComponentTransfer data-id="element-858" data-mp="3az2uuhdgl6i5">
            <feFuncA type="table" tableValues="0 0 0 0.7 1 1" data-id="element-859" data-mp="36z2cwmr5id6c" />
          </feComponentTransfer>
        </filter>
      </defs>
      <image href={alinovaLogoAsset} x="0" y="0" width="1920" height="1080" preserveAspectRatio="none" filter={`url(#${filterId})`} data-id="element-860" data-mp="31zfr3ox9bolx" />
    </svg>;
};
export const GradientText = ({
  children
}: {
  children: React.ReactNode;
}) => <span style={{
  background: `linear-gradient(135deg, ${DS.color.aqua}, ${DS.color.teal})`,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text'
}} data-id="element-861" data-mp="2natdbrna34wt">
    {children}
  </span>;
interface ConstellationProps {
  width?: number;
  height?: number;
  opacity?: number;
  rotation?: 'clockwise' | 'counter' | 'counterclockwise';
  style?: React.CSSProperties;
}
export const AlinovaConstellation = ({
  width = 200,
  height = 200,
  opacity = 0.1,
  rotation,
  style
}: ConstellationProps) => {
  const animClass = rotation === 'clockwise' ? 'anim-rotate-cw' : rotation === 'counter' || rotation === 'counterclockwise' ? 'anim-rotate-ccw' : undefined;
  return <svg width={width} height={height} viewBox="0 0 200 200" fill="none" className={animClass} style={{
    opacity,
    ...style
  }} aria-hidden="true" data-id="element-862" data-mp="2iep8j25kxc42">
      <path d="M100 60 L104 96 L140 100 L104 104 L100 140 L96 104 L60 100 L96 96 Z" stroke={DS.color.aqua} strokeWidth="1" fill="none" opacity="0.7" data-id="element-863" data-mp="2nfmnl5valq1c" />
      <circle cx="100" cy="100" r="3" fill={DS.color.aqua} opacity="0.6" data-id="element-864" data-mp="2dlmbgk1lfkj4" />
      {[[100, 30], [160, 60], [170, 140], [100, 170], [30, 140], [30, 60]].map(([cx, cy], index) => <g key={index} data-id="element-865" data-mp="uorhzk234afe" data-mpi={index}>
          <circle cx={cx} cy={cy} r="3" fill={DS.color.aqua} opacity="0.45" data-id="element-866" data-mp="unztsuathez5" />
          <line x1="100" y1="100" x2={cx} y2={cy} stroke={DS.color.aqua} strokeWidth="0.6" opacity="0.2" data-id="element-867" data-mp="pqzmyh65886z" />
        </g>)}
      {[[130, 45], [155, 100], [130, 155], [70, 155], [45, 100], [70, 45]].map(([cx, cy], index) => <circle key={index} cx={cx} cy={cy} r="1.5" fill={DS.color.aquaLight} opacity="0.3" data-id="element-868" data-mp="6rlqnskxyldb" data-mpi={index} />)}
    </svg>;
};
interface SmileDividerProps {
  fromColor: string;
  toColor: string;
  flip?: boolean;
}
export const SmileDivider = ({
  fromColor,
  toColor,
  flip = false
}: SmileDividerProps) => <div style={{
  position: 'relative',
  height: '72px',
  overflow: 'hidden',
  background: fromColor,
  transform: flip ? 'scaleY(-1)' : 'none'
}} data-id="element-869" data-mp="1w8d213cnx6s7">
    <svg viewBox="0 0 1440 72" preserveAspectRatio="none" style={{
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: '100%',
    display: 'block'
  }} data-id="element-870" data-mp="2ngfyxs1wujw5">
      <path d="M0,72 L0,36 Q360,0 720,36 Q1080,72 1440,36 L1440,72 Z" fill={toColor} data-id="element-871" data-mp="2whme9xstpont" />
    </svg>
  </div>;